// extracted by mini-css-extract-plugin
export default {"welcome":"Style_welcome__AX8WD","image":"Style_image__lsrNF"};